import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AuditProductInternetRoutes = defineRoute({
    record: {
        route: {
            path: "/audit-product-internet",
            component: () => loadView(import("./AuditProductInternetTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/audit-product-internet/update/:id",
            component: () => loadView(import("./AuditProductInternetUpdate.vue")),
        },
        build(id: string) {
            return `/audit-product-internet/update/${id}`;
        },
    },
    selectRecord: {
        route: {
            path: "/audit-product-internet-select",
            component: () => loadView(import("./AuditProductInternetSelectTable.vue")),
        },
    },
});
